"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignageBootstrapSchema = exports.SignageBootstapBaseSchema = exports.SignageBootstrapFailureSchema = exports.SignageBootstrapSuccessSchema = void 0;
const zod_extensions_1 = require("@reachmedianetwork/zod-extensions");
exports.SignageBootstrapSuccessSchema = zod_extensions_1.z.object({
    success: zod_extensions_1.z.literal(true),
});
exports.SignageBootstrapFailureSchema = zod_extensions_1.z.object({
    success: zod_extensions_1.z.literal(false),
    error: zod_extensions_1.z.unknown(),
});
exports.SignageBootstapBaseSchema = zod_extensions_1.z.object({
    startTime: zod_extensions_1.z.number(),
    endTime: zod_extensions_1.z.number(),
    initializationCounter: zod_extensions_1.z.number().optional(),
});
exports.SignageBootstrapSchema = zod_extensions_1.z.union([
    exports.SignageBootstapBaseSchema.and(exports.SignageBootstrapSuccessSchema),
    exports.SignageBootstapBaseSchema.and(exports.SignageBootstrapFailureSchema),
]);
//# sourceMappingURL=signageBootstrap.js.map